const isSP = () => {
    return window.innerWidth <= 835;
};

export { isSP };
